import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";

import { ROUTE_ELEMENTS } from "@/app/routeElements";
import { APP_ROUTES, type AppRouteDef } from "@/app/routes";
import { Layout, PermissionRoute, PrivateRoute } from "@/components/layout";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/shared/contexts/ThemeContext";

import { AuthProvider } from "./features";

/**
 * Envuelve el elemento de una ruta con las capas que le correspondan según su
 * definición: Layout, guardia de permiso y guardia de sesión, de dentro afuera.
 */
function renderRouteElement(route: AppRouteDef): React.ReactNode {
  const element = ROUTE_ELEMENTS[route.id];
  const withLayout = route.layout === false ? element : <Layout>{element}</Layout>;

  if (route.access === "public") {
    return withLayout;
  }

  const guarded = route.permission ? (
    <PermissionRoute
      permission={route.permission}
      mode={route.mode}
      redirectTo={route.redirectTo}
    >
      {withLayout}
    </PermissionRoute>
  ) : (
    withLayout
  );

  return <PrivateRoute>{guarded}</PrivateRoute>;
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <ThemeProvider>
          <div className="App">
            <Routes>
              {APP_ROUTES.map((route) => (
                <Route
                  key={route.id}
                  path={route.path}
                  element={renderRouteElement(route)}
                />
              ))}

              {/* Redirecciones */}
              <Route
                path="/reports"
                element={<Navigate to="/reports/business" replace />}
              />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </div>
          <Toaster />
        </ThemeProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
